import { render, staticRenderFns } from "./UtilCurrency.vue?vue&type=template&id=e57aca98"
import script from "./UtilCurrency.vue?vue&type=script&lang=js"
export * from "./UtilCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports